import React, { useState, useEffect } from "react";
import { CircleCheck, X } from "lucide-react";
import Message from "../../assets/icons/popup/e-lotto-pcso-logo 1.svg?react";
import QR from "../../assets/icons/popup/QR-CODE.svg?react";

export default function QrPopup({ isOpen, onClose }) {
  const [isVisible, setIsVisible] = useState(false); // Controls rendering in DOM
  const [isAnimating, setIsAnimating] = useState(false); // Controls animation classes
  const [showCopyPopup, setShowCopyPopup] = useState(false); // State for referral copy popup
  const [copyPopupAnimating, setCopyPopupAnimating] = useState(false); // Animation state for copy popup

  // Handle the main popup animation
  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
      setTimeout(() => setIsAnimating(true), 10);
    } else {
      setIsAnimating(false);
      const timer = setTimeout(() => setIsVisible(false), 300);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  // Handle the Copy Popup animation
  const handleCopyPopup = () => {
    setShowCopyPopup(true);
    setTimeout(() => setCopyPopupAnimating(true), 10); // Start animation
    setTimeout(() => {
      setCopyPopupAnimating(false); // End animation
      const timer = setTimeout(() => setShowCopyPopup(false), 300);
      return () => clearTimeout(timer);
    }, 3000); // Close copy popup after 3 seconds
  };

  return (
    <>
      {/* Main Popup */}
      {isVisible && (
        <div
          className={`fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50 transition-opacity duration-300 ${
            isAnimating ? "opacity-100" : "opacity-0"
          }`}
        >
          <div
            className={`relative w-full p-4 max-w-xs bg-white text-black rounded-3xl overflow-hidden transition-transform duration-300 ${
              isAnimating ? "scale-100" : "scale-90"
            }`}
          >
            {/* Close Button */}
            <button
              onClick={onClose}
              className="absolute right-4 top-4 text-gray-300 hover:text-white"
            >
              <X className="w-5 h-5" />
            </button>

            {/* Main Content */}
            <div className="px-4 text-center my-3 flex justify-center flex-col">
             
              <h2 className="text-xl font-semibold text-center my-2 leading-none">
                Scan QR Code
              </h2>
              <p className="text-xs font-normal mb-3">
                Scan this QR code to transection
              </p>

              {/* QR Code */}
              <div className="bg-white p-2 rounded-lg mx-auto shadow-md ">
                <QR className="w-56 h-56" />
              </div>

              {/* Referral Code */}
   

              {/* Buttons */}
            
            </div>
          </div>
        </div>
      )}


    </>
  );
}
